var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Row",
    { staticClass: "areaConfig no-cancel-tree" },
    [
      _c(
        "i-col",
        { staticClass: "left-box", attrs: { span: "9" } },
        [
          _c("h3", [_vm._v(_vm._s(_vm.$t("deviceSip.area")))]),
          _c("config-tree", {
            key: _vm.timeStamp,
            ref: "configTree",
            attrs: {
              "current-step": _vm.currentStep,
              "current-chosen-node": _vm.currentNode["$treeNodeId"],
            },
            on: { selectTree: _vm.selectTree },
          }),
        ],
        1
      ),
      _c("i-col", { staticClass: "right-box", attrs: { span: "14" } }, [
        _c(
          "div",
          { staticClass: "fun-box" },
          [
            _c(
              "Button",
              {
                staticClass: "pro-edit-color forbit-cancel-tree",
                attrs: { icon: "md-checkbox-outline", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.showAddAreaModal(1)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.editArea")) + " ")]
            ),
            _c(
              "Button",
              {
                staticClass: "pro-add-color forbit-cancel-tree",
                attrs: { icon: "md-add-circle", size: "large" },
                on: {
                  click: function ($event) {
                    return _vm.showAddAreaModal(0)
                  },
                },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.addArea")) + " ")]
            ),
            _c(
              "Button",
              {
                staticClass: "pro-batch-color forbit-cancel-tree",
                attrs: { icon: "md-albums", size: "large" },
                on: { click: _vm.showAddBatchAreaModal },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.batchArea")) + " ")]
            ),
            _c(
              "Button",
              {
                staticClass: "pro-del-color forbit-cancel-tree",
                attrs: { icon: "ios-trash", size: "large" },
                on: { click: _vm.showDelAreaModal },
              },
              [_vm._v(" " + _vm._s(_vm.$t("deviceSip.deleteArea")) + " ")]
            ),
          ],
          1
        ),
        _vm.currentNode.code
          ? _c("div", { staticClass: "content-box forbit-cancel-tree" }, [
              _c("h2", [_vm._v(_vm._s(_vm.$t("deviceSip.area")))]),
              _c("h4", [
                _c("span", [
                  _c("span", { staticClass: "error-color" }, [_vm._v("*")]),
                  _vm._v(" " + _vm._s(_vm.$t("deviceSip.areaName")) + " "),
                ]),
                _c("p", [_vm._v(_vm._s(_vm.currentNode.name))]),
              ]),
              _c("h4", [
                _c("span", [
                  _c("span", { staticClass: "error-color" }, [_vm._v("*")]),
                  _vm._v(" " + _vm._s(_vm.$t("deviceSip.areaNo")) + " "),
                ]),
                _c("p", [_vm._v(_vm._s(_vm.currentNode.code))]),
              ]),
            ])
          : _vm._e(),
      ]),
      _c(
        "i-col",
        { staticClass: "footer-btn forbit-cancel-tree", attrs: { span: "24" } },
        [
          _c(
            "Button",
            {
              attrs: { type: "primary", ghost: "", size: "large" },
              on: {
                click: function ($event) {
                  return _vm.setCurrentStep(0)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("deviceSip.prev")) + " ")]
          ),
          _c(
            "Button",
            {
              staticClass: "forbit-cancel-tree",
              attrs: { type: "primary", size: "large" },
              on: {
                click: function ($event) {
                  return _vm.setCurrentStep(2)
                },
              },
            },
            [_vm._v(" " + _vm._s(_vm.$t("deviceSip.next")) + " ")]
          ),
        ],
        1
      ),
      _c("add-area-modal", {
        ref: "addAreaModal",
        attrs: { "area-type": _vm.areaType, "current-node": _vm.currentNode },
        on: { updateTree: _vm.updateTree },
      }),
      _c("add-batch-area-modal", {
        ref: "addBatchAreaModal",
        attrs: { "current-node": _vm.currentNode },
        on: { updateTree: _vm.updateTree },
      }),
      _c(
        "confirmModal",
        {
          ref: "confirmModal",
          staticClass: "forbit-cancel-tree",
          on: { afterComfirm: _vm.delArea },
        },
        [
          _c("div", { attrs: { slot: "info" }, slot: "info" }, [
            _c("p", { staticClass: "p-text" }, [
              _vm._v(
                " " +
                  _vm._s(_vm.$t("updateNewSip.deleteArea1")) +
                  '"' +
                  _vm._s(_vm.delNamePath) +
                  '"? '
              ),
            ]),
            _c("p", { staticClass: "p-text" }, [
              _vm._v(_vm._s(_vm.$t("updateNewSip.deleteArea2"))),
            ]),
          ]),
        ]
      ),
      _c("modal", {
        ref: "resultModal",
        staticClass: "forbit-cancel-tree",
        attrs: { type: _vm.modalType },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }